import $ from 'jquery';

function Footer(element, $footprint) {
  this.$element = $(element);
  this.$footprint = $footprint;
  this.update = $.proxy(this.update, this);
  this.init();
}

Footer.prototype = {
  init() {
    this.addEventListeners();
    this.update();
    this.ready();
  },
  update() {
    const $foot = this.$footprint;
    const $elem = this.$element;
    window.setTimeout(() => {
      $foot.height($elem.outerHeight());
    }, 50);
  },
  ready() {
    this.$element.addClass('ready');
  },
  addEventListeners() {
    $(window).bind('resize', this.update);
    $(window).bind('orientationChange', this.update);
  },
};

export default Footer;



// WEBPACK FOOTER //
// ./Footer.js